export default __webpack_public_path__ + "static/why-ml-3--mobile-33f8151838ad82c1a76c31ec6f1b18c5.webp";